"use client"

import { useState } from "react"
import { ChevronDown } from "lucide-react"
import "./grades.css"

const Grades = () => {
  const [activePhase, setActivePhase] = useState(1)
  const [showDetails, setShowDetails] = useState(false)
  const [activeTab, setActiveTab] = useState(0)

  const phases = [
    {
      id: 1,
      number: 1,
      title: "مرحلة الوعي والانساق",
      description:
        "ورشة عمل واحدة تعمل على تهيئة المشارك لتلقي المعارف والمهارات التنظيمية، من خلال التركيز على اتساق ممارساته المهنية مع طبيعته وميوله ونمط شخصيته القيادية.",
      details: [
        {
          tab: " إدارة الــذات",
          content: [
            "أنماط الشخصية القيادية وأساليبها",
            "القيادة والأخلاق المهنية",
            "القدوة والشجاعة الأخلاقية",
            "إدارة المحادثات",
            "التعاطف والقيادة الرحيمة",
            "القيم الشخصية والمؤسسية",
            "بناء الثقة"
 
           ]  
        },
       
      ],
    },
    {
      id: 2,
      number: 2,
      title: "مرحلة التوجيه التنظيمي",
      description:"ورشة عمل واحدة ترسخ المفاهيم والآليات المنتهجة لتوليد الاستراتيجيات وتقييم المخاطر. وتتناول تخطيط التغيير وطرق دعم الابتكار وتأسيس الفكر الريادي.",
      details: [
        {
          tab: "الــرؤية التنظــيمية",

        content: [
         "التفكير والنماذج الاستراتيجية",
         "الإدارة العاطفية ونماذج التغيير",
         "إدارة المخاطر التنظيمية",
         "الإبداع التنظيمي ونمذجة الدورات",
         "الريادة التنظيمية وإدارة النمو",

         ]  
        },
        
      ],
    },
    {
      id: 3,
      number: 3,
      title: "مرحلة الفعل والإنجاز",
      description:
"ورشتا عمل تنميان جدارات المرونة والتكيف، وعناصر إدارة الأداء، ثم التوجيه والانتاجية وبيئة العمل الصحية، وضمانات الاستدامة وتطوير المواهب وتخطيط التعاقب."  ,
    details: [
        {
          tab: " الأداء المهــني",
          content: [
          'قيادة الأداء المهني',
          "العافية المهنية والتوازن النفسي",
          "الإرشاد في بيئة العمل",
          "التوظيف والتاهيل وإدارة الخروج",
          "سياق وتقنيات التوجيه المهني"
   
            ]  

        },
        {
          tab: " النمــو والاســتدامة ",
          content: [
          "عقلية النمو وإدارة الأزمات",
          "القيادة التكيفية والقيادة الرشيقة",
          "تعظيم مخرجات التشغيل",
          "الاستدامة والاختيارات التعاقدية",
          "تطوير المواهب وتخطيط التعاقب",

   
            ]  
        },
       
      ],
    },
    {
      id: 4,
      number: 4,
      title: "مرحلة التطوير والنمو",
      description: "ورشتا عمل تناقشان تطوير الثقافة المؤسسية وجدارات بناء الكوادر المعززة للقدرة المؤسسية، وما يرتبط بها من معالجات تحليلية وممارسات تفاعلية مع فرق العمل.",
      details: [
        {
          tab: " تمكــين الكــوادر",
          content: [
            "الإدارة التصاعدية والإبداع التشاركي",
            "تمكين الكوادر والتعلم من الخطأات",
            "السمعة والعلامة الشخصية",
     
              ]  ,
        },
        {
          tab: "المســؤولية والقــرار",
          content: [
          "رصد الفرص والتوجهات",
          "الدراسة والتحليل والكيانات القانونية",
          "التفكير الناقد واتخاذ القرار",
          "المسؤولية المجتمعية ومواطنة المنظمة",


  
     
              ]  

        },
      
      ],
    },
    {
      id: 5,
      number: 5,
      title: "مرحلة الفعالية التنظيمية",
      description: "ورشتا عمل تكملان البناء القيادي بربط الكوادر بالمنظمة من خلال تفعيل قدرات المشارك في العمل الجماعي والتواصل المؤسسي وإدارة العلاقات التشاركية داخل المنظمة وخارجها.",
      details: [
        {
          tab: " البــرامج والمشــروعات",
          content: [
            "أدوات وتقنيات قيادة المشروع",
            "توجيه العنصر البشري في المشروعات",
            "التفاوض وإدارة النزاعات",
            "إشراك أصحاب المصلحة"
  
  
    
       
                ]  
        },
        {
          tab: "العلاقــات المهــنية",
          content: [
           "العمل الجماعي وأصحاب المصلحة",
           "التشبيك واحترام التنوع",
           "البرامج وعلاقات العملاء",
           "آليات الوساطة"
  
  
    
       
                ]          },
        
      ],
    },
  ]

  const handlePhaseClick = (phaseId) => {
    setActivePhase(phaseId)
    setShowDetails(false)
  }

  const toggleDetails = () => {
    setShowDetails(!showDetails)
    setActiveTab(0)
  }

  const handleTabClick = (index) => {
    setActiveTab(index)
  }

  const activePhaseData = phases.find((phase) => phase.id === activePhase)

  return (
    <div className="program-design-container">
      <div className="program-header-g">
        <h2 className="program-title">فلسفة تصميم البرنامج</h2>
        <div className="program-subtitle">
          يمتد البرنامج ستة أشهر نوزع فيها المراحل الخمس للبرنامج على أمان وورش عمل متصلة تمثل مراحل تطوير قدرات القيادة
          التطبيقية
        </div>
      </div>

      <div className="program-content">
        <div className="phases-details">
          <h3 className="details-title">تفاصيل المرحلة</h3>
          <div className="details-content">{activePhaseData.description}</div>

          <button className="details-toggle" onClick={toggleDetails}>
            <span>تفاصيل المرحلة</span>
            <ChevronDown className={`details-icon ${showDetails ? "rotated" : ""}`} />
          </button>

          {showDetails && (
             <div className="details-tabs">
             <div className="tabs-header">
               {activePhaseData.details.map((detail, index) => (
                 <button
                   key={index}
                   className={`tab-button ${activeTab === index ? "active" : ""}`}
                   onClick={() => handleTabClick(index)}
                 >
                   {detail.tab}
                 </button>
               ))}
             </div>
             <div className="tab-content">
               <ul>
                 {activePhaseData.details[activeTab].content.map((item, index) => (
                   <li key={index}><i class="far fa-check-circle"></i>{item}</li>
                 ))}
               </ul>
             </div>
           </div>
          )}
        </div>

        <div className="phases-list">
          {phases.map((phase) => (
            <div
              key={phase.id}
              className={`phase-item ${activePhase === phase.id ? "active" : ""}`}
              onClick={() => handlePhaseClick(phase.id)}
            >
              <div className="phase-number">{phase.number}</div>
              <div className="phase-title">{phase.title}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Grades
